
const digest = '06430804fa7198b2500b22c73f4bb0664cfb574718c3ad7a6aae1de9490ff07b';
const classes = {"wrapper":"_wrapper_juhpu_1","options":"_options_juhpu_7","submitButton":"_submitButton_juhpu_17","title":"_title_juhpu_21"};
const css = `._wrapper_juhpu_1 {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #eaedf3;
}
._wrapper_juhpu_1 ._options_juhpu_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_juhpu_1 ._submitButton_juhpu_17 {
  width: fit-content;
  margin: 12px;
}
._wrapper_juhpu_1 ._title_juhpu_21 {
  font-family: "Rubik", sans-serif;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  padding: 0 24px;
  margin: 15px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  